<template>
  <modal :modal-key="'level_up'" :class-style="'modal--levelup'"
         @close="$emit('close')">
    <template slot="header">
      <h1>{{ getTranslations.home_modals_level_up_congratz
        }}<br>{{ getTranslations.home_modals_level_up_lvl_progression }} {{ getShowmodalForLevelUp.userLevel }}!</h1>

    </template>
    <template slot="body">
      <div class="level-info">
        <div class="level-info__item">
          <span class="desc">{{ getTranslations.home_modals_level_up_bonus_points }}</span>
          <span class="score-lbl">{{ getShowmodalForLevelUp.bonusPoints }}</span>
        </div>
        <div class="level-info__item">
          <span class="desc">{{ getTranslations.home_modals_level_up_games_earned }}</span>
          <span class="score-lbl">{{ getShowmodalForLevelUp.gamesEarned }}</span>
        </div>
      </div>
      <span class="share_text" v-if="facebookFunctionality && getFbPoints !== 0 && !hasShare">{{ getTranslations.home_fb_share_share_on }} {{ getFbPoints }} {{ getTranslations.home_fb_share_bonus_points }}</span>
      <a v-if="facebookFunctionality" href="#" class="fb_btn btn--icon" @click.prevent="shareLevelUp()"><i
        class="icon-facebook"></i><span>{{ getTranslations.home_fb_share_share }}</span></a>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 104.5"><title>rocket_animation</title>
        <g class="cls-1">
          <g id="Layer_2" data-name="Layer 2">
            <!-- eslint-disable -->
            <g id="clouds">
              <path class="cls-2"
                    d="M99.17,71.85a9.24,9.24,0,0,0-8.81,6.46,10.41,10.41,0,0,0-14-1.74A11.41,11.41,0,0,0,71.06,71a6.48,6.48,0,0,0-12.94.34,9.67,9.67,0,0,0-11.88,4.76,9.83,9.83,0,0,0-17-2.14A10.83,10.83,0,0,0,11,79.11a7.61,7.61,0,0,0-8.14,2.76c-.3,0-.59,0-.89,0A14.84,14.84,0,0,0,0,82v20.85H15.19a14.58,14.58,0,0,0,1.45-6.33,14.6,14.6,0,0,0-1.22-5.86l0-.08a10.82,10.82,0,0,0,15.29-3.28,9.82,9.82,0,0,0,15.16-3.1,9.68,9.68,0,0,0,12.4,5.36A11.35,11.35,0,0,0,73.21,90a10.43,10.43,0,0,0,19.36-2.42,9.2,9.2,0,0,0,6.6,2.78c.28,0,.56,0,.83,0V71.9C99.73,71.87,99.45,71.85,99.17,71.85Z"/>
              <path class="cls-3"
                    d="M64.76,54q-1.31,20.79-2.62,41.58a105.83,105.83,0,0,0,13.26,0L72.8,54A63.86,63.86,0,0,1,64.76,54Z"/>
              <path class="cls-3"
                    d="M2,83.5a14.67,14.67,0,0,0-2,.15V104.5H15.19a14.58,14.58,0,0,0,1.45-6.33A14.67,14.67,0,0,0,2,83.5Z"/>
              <path class="cls-3" d="M26,83.5a14.64,14.64,0,0,0-13.21,21H39.19A14.64,14.64,0,0,0,26,83.5Z"/>
              <path class="cls-3"
                    d="M52.43,81.17A14.65,14.65,0,0,0,40.62,104.5H64.25A14.65,14.65,0,0,0,52.43,81.17Z"/>
              <path class="cls-3" d="M78.27,83.5a14.64,14.64,0,0,0-13.21,21H91.48a14.64,14.64,0,0,0-13.21-21Z"/>
              <path class="cls-3" d="M100,87.66A14.57,14.57,0,0,0,83.47,104.5H100Z"/>
              <path class="cls-3" d="M63.6,92a14.66,14.66,0,0,0-14.49,12.5h29A14.66,14.66,0,0,0,63.6,92Z"/>
              <path class="cls-3"
                    d="M29.41,93.67A14.66,14.66,0,0,0,15.26,104.5H43.55A14.66,14.66,0,0,0,29.41,93.67Z"/>
              <path class="cls-3"
                    d="M7.41,93.67a14.58,14.58,0,0,0-7.41,2v8.81H21.55A14.66,14.66,0,0,0,7.41,93.67Z"/>
              <circle class="cls-3" cx="18.31" cy="84.33" r="7.67"/>
              <circle class="cls-3" cx="8.98" cy="88.17" r="7.67"/>
              <circle class="cls-3" cx="21.55" cy="83.27" r="10.83"/>
              <circle class="cls-3" cx="37.13" cy="81.46" r="9.84"/>
              <circle class="cls-3" cx="68.17" cy="85.8" r="6.48"/>
              <circle class="cls-3" cx="82.43" cy="86.76" r="10.44"/>
              <path class="cls-3"
                    d="M99.17,73.53a9.24,9.24,0,0,0,0,18.47c.28,0,.56,0,.83,0V73.57C99.73,73.54,99.45,73.53,99.17,73.53Z"/>
              <circle class="cls-3" cx="66" cy="82.83" r="11.38"/>
              <circle class="cls-3" cx="53.65" cy="84.82" r="6.48"/>
              <circle class="cls-3" cx="64.6" cy="73.06" r="6.48"/>
              <circle class="cls-3" cx="54.89" cy="82.14" r="9.71"/>
              <circle class="cls-3" cx="92.93" cy="88.17" r="4.9"/>
              <circle class="cls-3" cx="78.37" cy="84.33" r="4.9"/>
              <circle class="cls-3" cx="49.94" cy="84.82" r="6.48"/>
              <path class="cls-4" d="M100,96.94a14.65,14.65,0,0,0-17.57,7.56H100Z"/>
              <path class="cls-4" d="M71.6,96.27a14.65,14.65,0,0,0-13.16,8.23H84.76A14.65,14.65,0,0,0,71.6,96.27Z"/>
              <path class="cls-4"
                    d="M45.14,93.93A14.66,14.66,0,0,0,31.07,104.5H59.22A14.66,14.66,0,0,0,45.14,93.93Z"/>
              <path class="cls-4"
                    d="M19.31,96.27A14.65,14.65,0,0,0,6.14,104.5H32.47A14.65,14.65,0,0,0,19.31,96.27Z"/>
              <path class="cls-4" d="M0,104.5H9.94A14.61,14.61,0,0,0,0,100.29Z"/>
              <path class="cls-4" d="M79.93,97.58a7.67,7.67,0,1,0-11,6.92h6.58A7.66,7.66,0,0,0,79.93,97.58Z"/>
              <path class="cls-4" d="M88.6,93.27a7.66,7.66,0,0,0-6.78,11.23H95.38A7.66,7.66,0,0,0,88.6,93.27Z"/>
              <path class="cls-4" d="M75.83,98.77a7.67,7.67,0,1,0-12.74,5.73H73.25A7.64,7.64,0,0,0,75.83,98.77Z"/>
              <circle class="cls-4" cx="57.09" cy="97.58" r="6.48"/>
              <circle class="cls-4" cx="35.02" cy="93.25" r="6.48"/>
              <path class="cls-4" d="M17.61,98.77A6.48,6.48,0,1,0,8.1,104.5h6A6.48,6.48,0,0,0,17.61,98.77Z"/>
              <path class="cls-4" d="M4.64,98.28A6.48,6.48,0,0,0,0,92.07V104.5A6.49,6.49,0,0,0,4.64,98.28Z"/>
              <path class="cls-4" d="M26.49,93.78a6.48,6.48,0,0,0-4.9,10.72H31.4a6.48,6.48,0,0,0-4.9-10.72Z"/>
              <circle class="cls-4" cx="43.92" cy="97.58" r="6.48"/>
              <circle class="cls-4" cx="57.43" cy="92.28" r="7.84"/>
              <circle class="cls-4" cx="68.78" cy="89.23" r="6.48"/>
              <circle class="cls-4" cx="35.89" cy="97.58" r="6.48"/>
              <circle class="cls-4" cx="72.8" cy="86.35" r="6.48"/>
              <circle class="cls-4" cx="63.43" cy="83.02" r="6.7"/>
              <path class="cls-4"
                    d="M9.54,100.93A4.89,4.89,0,0,0,0,99.43v3a4.88,4.88,0,0,0,1.3,2.07H8A4.87,4.87,0,0,0,9.54,100.93Z"/>
              <circle class="cls-4" cx="19.21" cy="97.1" r="4.9"/>
              <circle class="cls-4" cx="45.18" cy="92.83" r="6.48"/>
              <circle class="cls-4" cx="80.93" cy="94.21" r="6.48"/>
              <path class="cls-4"
                    d="M66.45,57.62,64.93,88.35a48.26,48.26,0,0,0,7.7,0L71.11,57.62A29.26,29.26,0,0,1,66.45,57.62Z"/>
              <rect class="cls-5" width="100" height="104.07"/>
              <g id="rocket">
                <path class="cls-6" d="M68.52,103.22l.26.46V84.53C66.64,85.66,61.07,90.05,68.52,103.22Z"/>
                <path class="cls-7" d="M68.78,84.53v19.14l.26-.46C76.49,90.05,70.92,85.66,68.78,84.53Z"/>
                <path class="cls-8"
                      d="M62,73.08l-3.26,5.33a4.46,4.46,0,0,0-.57,3.31l2,9,4.48-8.56S66.18,73.76,62,73.08Z"/>
                <path class="cls-8"
                      d="M75.54,73.08c-4.16.68-2.62,9-2.62,9l4.48,8.56,2-9a4.47,4.47,0,0,0-.57-3.31Z"/>
                <path class="cls-9"
                      d="M68.78,57.3h0a10.11,10.11,0,0,1-5.26-1.52,27,27,0,0,0-2.42,13.38,53.63,53.63,0,0,0,2.84,14.25,9.77,9.77,0,0,0,9.75,0A53.59,53.59,0,0,0,76.5,69.16a27,27,0,0,0-2.44-13.42A10.12,10.12,0,0,1,68.78,57.3Z"/>
                <path class="cls-8"
                      d="M68.79,49.38a16.58,16.58,0,0,0-5.3,6.4,10.1,10.1,0,0,0,5.26,1.52h0a10.12,10.12,0,0,0,5.28-1.55A16.58,16.58,0,0,0,68.79,49.38Z"/>
                <circle class="cls-8" cx="68.78" cy="63.43" r="3.7"/>
                <circle class="cls-4" cx="68.78" cy="63.43" r="3.01"/>
                <path class="cls-4"
                      d="M63.91,83.41c0,.14.08.28.13.42.18.53.37,1.06.56,1.61a9.87,9.87,0,0,0,4.15.93h0a9.89,9.89,0,0,0,4.18-1q.29-.81.55-1.59l.13-.4a9.77,9.77,0,0,1-9.75,0Z"/>
                <path class="cls-8" d="M68.78,91c2.79-13.87,0-17.07,0-17.07S66,77.08,68.78,91Z"/>
                <g class="cls-10">
                  <path class="cls-4"
                        d="M68.74,57.29h0a10.11,10.11,0,0,1-5.26-1.52,27,27,0,0,0-2.42,13.38,43.12,43.12,0,0,0,.48,4.69l-2.79,4.56a4.47,4.47,0,0,0-.57,3.31l2,9,3.77-7.2.11.35c.18.53.37,1.06.56,1.61a10,10,0,0,0,3.39.89c.19,1.39.45,2.93.79,4.62V57.29h0Z"/>
                  <path class="cls-4"
                        d="M63.49,55.77a10.11,10.11,0,0,0,5.25,1.52h0V49.38A16.59,16.59,0,0,0,63.49,55.77Z"/>
                </g>
              </g>
            </g>
            <!-- eslint-enable -->
          </g>
        </g>
      </svg>
    </template>
    <span class="fb_error_msg" v-if="fb_error && facebookFunctionality">{{ getTranslations.home_fb_share_this_fb_account }}</span>
  </modal>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import { Howl } from 'howler';
import Modal from '@/components/home/modals/shared/GenericModal';
import FacebookMixin from '@/common/mixins/facebookIntegration';
import RoundUpMixin from '@/common/mixins/roundUp';

export default {
  name: 'level-up',
  mixins: [FacebookMixin, RoundUpMixin],
  components: {
    Modal,
  },
  data() {
    return {
      action: 'LEVEL_UP',
      image: '',
      points: '',
      hasShare: false,
      redirectUrl: '',
      fb_error: false,
      levelUpSound: new Howl({
        src: ['static/sounds/Levelup.ogg', 'static/sounds/Levelup.mp3'],
      }),
    };
  },
  created() {
    this.redirectUrl = `${window.location.href}/${this.userDetails.level}/${this.getLocale || localStorage.getItem('locale')}/`;
    // eslint-disable-next-line
    console.log('redirectUrl: ', this.redirectUrl);
    this.hasAlreadyShare().then((response) => {
      this.getUserLoginDetails().then(() => {
        if (response.data && response.data >= this.userDetails.level) {
          this.hasShare = true;
        } else {
          this.forceFbToScrapNewMetadata(this.redirectUrl, () => {
            // eslint-disable-next-line
            console.log('successful scrapping!');
          });
        }
      });
    });
  },
  mounted() {
    this.levelUpSound.play();
  },
  methods: {
    ...mapActions('profile', [
      'getLastSharedLevel',
      'giveContent',
      'getUserLoginDetails',
    ]),
    hasAlreadyShare() {
      return this.getLastSharedLevel();
    },
    assignPoints() {
      this.giveContent({ action: 'LEVEL_UP', points: this.getFbPoints }).then((response) => {
        if (response.data.responseEnum === 'OPERATION_SUCCESS') {
          this.hasShare = true;
        }
      });
    },
    showError() {
      this.fb_error = true;
    },
    shareLevelUp() {
      this.fb_error = false;
      this.points = this.getFbPoints;
      this.share(
        this.userDetails.facebookId,
        this.userDetails.id,
        this.assignPoints,
        this.showError,
      );
    },
  },
  computed: {
    getFbPoints() {
      const userPoints = (this.userDetails.facebookId ? this.userDetails.totalPointsEarned : this.userDetails.totalPointsEarned + this.connectionPoints);
      return this.roundUpNumber(Math.floor(userPoints * 0.05));
    },
    ...mapState('common', [
      'soundsOn',
      'userDetails',
      'facebookFunctionality',
      'connectionPoints',
    ]),
    ...mapState('profile', [
      'dailyPrize',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getLocale',
    ]),
    ...mapGetters('profile', [
      'getShowmodalForLevelUp',
    ]),
  },
};
</script>

<style>
  .cls-1 {
    isolation: isolate;
  }

  .cls-2, .cls-3 {
    fill: #87d8de;
  }

  .cls-2 {
    opacity: 0.5;
    mix-blend-mode: multiply;
  }

  .cls-4 {
    fill: #fff;
  }

  .cls-5 {
    fill: none;
  }

  .cls-6 {
    fill: #f7d033;
  }

  .cls-7 {
    fill: #f5c400;
  }

  .cls-8 {
    fill: #f37252;
  }

  .cls-9 {
    fill: #2d3c50;
  }

  .cls-10 {
    opacity: 0.1;
  }
</style>



// WEBPACK FOOTER //
// src/components/home/modals/LevelUp.vue